<div class="contenedor-grupo-botones">
  <button *ngFor="let boton of botones" (click)="handleClick(boton)"
  [ngClass]="{'boton-seleccionado':boton === seleccionado}">
    {{boton}}
  </button>
</div>
